import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Heart, Loader2, ArrowRight } from 'lucide-react';
import { api } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';

const FavoritesPage = () => {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFavorites();
  }, []);

  const fetchFavorites = async () => {
    try {
      const res = await api.get('/favorites');
      setFavorites(res.data);
    } catch (error) {
      console.error('Error fetching favorites:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = async (producerId) => {
    try {
      await api.delete(`/favorites/${producerId}`);
      setFavorites(prev => prev.filter(f => f.producer.id !== producerId));
      toast.success('Rimosso dai preferiti');
    } catch (error) {
      toast.error('Errore durante la rimozione');
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background" data-testid="favorites-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="font-heading text-3xl font-bold text-text-primary mb-8">
          I Miei Preferiti
        </h1>

        {favorites.length === 0 ? (
          <div className="text-center py-16 bg-white rounded-xl border border-border">
            <Heart className="w-16 h-16 mx-auto text-text-muted mb-4" />
            <h2 className="text-xl font-bold text-text-primary mb-2">Nessun preferito</h2>
            <p className="text-text-secondary mb-6">
              Non hai ancora aggiunto produttori ai preferiti
            </p>
            <Button asChild>
              <Link to="/produttori">
                Scopri i Produttori
                <ArrowRight className="w-4 h-4 ml-2" />
              </Link>
            </Button>
          </div>
        ) : (
          <div className="space-y-4">
            {favorites.map(({ producer, created_at }) => (
              <div
                key={producer.id}
                className="bg-white p-4 rounded-xl border border-border flex items-center gap-4"
              >
                <Link to={`/produttori/${producer.slug}`}>
                  <img
                    src={producer.logo_url || 'https://images.pexels.com/photos/15899638/pexels-photo-15899638.jpeg'}
                    alt={producer.name}
                    className="w-16 h-16 rounded-lg object-cover"
                  />
                </Link>
                
                <div className="flex-1 min-w-0">
                  <Link 
                    to={`/produttori/${producer.slug}`}
                    className="font-semibold text-text-primary hover:text-primary transition-colors"
                  >
                    {producer.name}
                  </Link>
                  {producer.description && (
                    <p className="text-sm text-text-secondary line-clamp-1 mt-1">
                      {producer.description}
                    </p>
                  )}
                </div>

                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => handleRemove(producer.id)}
                  className="text-red-500 hover:text-red-600 hover:bg-red-50"
                >
                  <Heart className="w-5 h-5 fill-current" />
                </Button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FavoritesPage;
